/** 提现路由 */
export default {
    name: 'withdrawal',
    path: 'withdrawal',
    meta: {
        title: '提现'
    },
    component: ()=>import('@/pages/withdrawal/withdrawal.vue'),
    children: []
}